import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    action: "#",
    method: "POST"
};
const _hoisted_2 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_3 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            First & Second Line Approval\n          ")
], -1);
const _hoisted_5 = { class: "mt-6" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("label", {
    for: "first_line",
    class: "block text-sm font-medium text-gray-700"
}, "Who provided first line approval for this ATR?", -1);
const _hoisted_7 = ["value", "disabled"];
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm" }, "The first line approver is the business representative who has the authority to approve the budget spend for this role.", -1);
const _hoisted_9 = { class: "mt-6" };
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("label", {
    for: "first_date",
    class: "block text-sm font-medium text-gray-700"
}, "First line approval date:", -1);
const _hoisted_11 = ["value", "disabled"];
const _hoisted_12 = { class: "mt-6" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("label", {
    for: "first_line_comments",
    class: "block text-sm font-medium text-gray-700"
}, "First line approval comments:", -1);
const _hoisted_14 = ["value", "disabled"];
const _hoisted_15 = { class: "mt-6" };
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("label", {
    for: "approval_comments",
    class: "block text-sm font-medium text-gray-700"
}, "Who provided second line approval for this ATR?:", -1);
const _hoisted_17 = ["value", "disabled"];
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm" }, "The second line approver is the HR professional who will ensure all the correct policies and approvals have\n            been adhered to. If further approvals are required, they will co-ordinate this with the business outside the\n            system and keep records locally for audit purposes.\n        ", -1);
const _hoisted_19 = { class: "mt-6" };
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("label", {
    for: "second_line_date",
    class: "block text-sm font-medium text-gray-700"
}, "Second line approval date:", -1);
const _hoisted_21 = ["value", "disabled"];
const _hoisted_22 = { class: "mt-6" };
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("label", {
    for: "second_line_comments",
    class: "block text-sm font-medium text-gray-700"
}, "Second line approval comments:", -1);
const _hoisted_24 = ["value", "disabled"];
import { computed, inject } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'amendsApprovals',
    props: {
        data: {},
        disableForm: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const formatDate = inject('formatDate');
        const secondLineApprovalComment = computed(() => {
            if (props.data?.approvalComments) {
                const approvalComment = props.data?.approvalComments.find((ac) => ac.stage === 'amend.notifyHROps');
                return approvalComment?.approvalComment ?? '';
            }
            return '';
        });
        const firstLineApprovalComment = computed(() => {
            if (props.data?.approvalComments) {
                const approvalComment = props.data?.approvalComments.find((ac) => ac.stage === 'amend.notifyBudgetApprover');
                return approvalComment?.approvalComment ?? '';
            }
            return '';
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("form", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_5, [
                            _hoisted_6,
                            _createTextVNode(),
                            _createElementVNode("input", {
                                value: props.data.amend_notifyBudgetApproverApproval?.approverEmail,
                                type: "text",
                                name: "first_line",
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:cursor-not-allowed",
                                disabled: _ctx.disableForm
                            }, null, 8, _hoisted_7)
                        ]),
                        _createTextVNode(),
                        _hoisted_8,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_9, [
                            _hoisted_10,
                            _createTextVNode(),
                            _createElementVNode("input", {
                                value: _unref(formatDate)(props.data.amend_notifyBudgetApproverApproval?.timeStamp, 'DD/MM/yyyy'),
                                type: "text",
                                name: "first_date",
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:cursor-not-allowed",
                                disabled: _ctx.disableForm
                            }, null, 8, _hoisted_11)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_12, [
                            _hoisted_13,
                            _createTextVNode(),
                            _createElementVNode("textarea", {
                                value: firstLineApprovalComment.value,
                                rows: "3",
                                name: "first_line_comments",
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:cursor-not-allowed",
                                disabled: _ctx.disableForm
                            }, null, 8, _hoisted_14)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_15, [
                            _hoisted_16,
                            _createTextVNode(),
                            _createElementVNode("input", {
                                value: props.data.amend_notifyHROpsApproval?.approverEmail,
                                type: "text",
                                name: "approval_comments",
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:cursor-not-allowed",
                                disabled: _ctx.disableForm
                            }, null, 8, _hoisted_17)
                        ]),
                        _createTextVNode(),
                        _hoisted_18,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_19, [
                            _hoisted_20,
                            _createTextVNode(),
                            _createElementVNode("input", {
                                value: _unref(formatDate)(props.data.amend_notifyHROpsApproval?.timeStamp, 'DD/MM/yyyy'),
                                type: "text",
                                name: "second_line_date",
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:cursor-not-allowed",
                                disabled: _ctx.disableForm
                            }, null, 8, _hoisted_21)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_22, [
                            _hoisted_23,
                            _createTextVNode(),
                            _createElementVNode("textarea", {
                                value: secondLineApprovalComment.value,
                                rows: "3",
                                name: "second_line_comments",
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:cursor-not-allowed",
                                disabled: _ctx.disableForm
                            }, null, 8, _hoisted_24)
                        ])
                    ])
                ])
            ]));
        };
    }
});
